






































import { Component, Vue } from 'vue-property-decorator';

import SingUpService from '@/api/SingupService';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import SelectLoyaltyReward from '@/componentsV2/molecules/SelectLoyaltyReward/SelectLoyaltyReward.vue';
import {
  BusinessOnboardingLink,
  BusinessOnboardingState
} from '@/models/business-onboarding';
import { IBusinessType } from '@/models/business';
import { RewardsProgramFormState } from '@/models/rewards-program';
import { EBusinessProviders } from '@/components/BusinessTypeSelector/business-providers.enum';
import flagKeys from '@/constants/flagKeys';
import {
  getOauthState,
  isExternalOauthSessionOnline
} from '@/router/router-utils';
import segmentIo from '@/utils/segment.io';
import { isBothProvider } from '@/utils/provider';
import { OnlineOnboardingURL } from '@/views/Onboarding/helpers';

@Component({
  components: {
    FilledButton,
    SelectLoyaltyReward
  }
})
export default class BOChooseLoyaltyReward extends Vue {
  loading = false;
  signUpService = new SingUpService();

  selected = '';

  OnlineOnboardingURL = OnlineOnboardingURL;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get isValidForm() {
    return !!this.selected;
  }

  get businessOnboardingState(): BusinessOnboardingState {
    return this.$store.getters[
      'businessOnboarding/getBusinessOnboardingState'
    ] as BusinessOnboardingState;
  }

  get links() {
    return this.$store.getters[
      'businessOnboarding/getNavLinks'
    ] as BusinessOnboardingLink[];
  }

  get rewardsProgramFormData() {
    return this.$store.getters[
      'rewardsProgram/getFormData'
    ] as RewardsProgramFormState;
  }

  get currentProvider() {
    return (
      this.$store.getters['merchant/getConnectedProviderWithWidgetSettings'] ||
      {}
    );
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get chooseLoyalyFlag() {
    return this.flags.includes(flagKeys.addWixMultipleIntegration);
  }

  get isChooseLoyalty() {
    const oAuthState = getOauthState();

    return (
      isBothProvider((this.currentProvider.name ||
        (oAuthState.provider
          ? oAuthState.provider.name
          : '')) as EBusinessProviders) &&
      this.businessOnboardingState.yourStore.form.operationType ===
        IBusinessType.BOTH &&
      this.chooseLoyalyFlag
    );
  }

  filterOptions(item: any) {
    return item.value !== IBusinessType.INSTORE;
  }

  selectLoyalty(value: string) {
    this.selected = value;
    this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
      operationType: value
    });
  }

  async onSubmit() {
    if (!this.isValidForm) {
      this.$notification('Please select an option', 'error');
      return;
    }

    segmentIo.track('Selected SignUp Loyalty Rewards Operation', {
      Operation: this.selected
    });

    this.$router.push(OnlineOnboardingURL.REWARD_RATIO);
  }

  created() {
    if (!this.isChooseLoyalty) {
      this.$router.replace(OnlineOnboardingURL.REWARD_RATIO);
    } else {
      segmentIo.page('NPO Sign Up/Choose Loyalty Reward', {
        'Signup Online': !!isExternalOauthSessionOnline()
      });
      this.selected = this.rewardsProgramFormData.operationType || '';
    }
  }
}
